import React from 'react';
import './AgendaItemEnd.sass';

interface Props {
    time: any;
}

function AgendaItem (props: Props) {

    const time = props?.time.endDayTime
    const hours = (new Date(time)).getHours().toString().length === 1 ? `0${(new Date(time)).getHours()}` : (new Date(time)).getHours()
    const minutes = (new Date(time)).getMinutes().toString().length === 1 ? `0${(new Date(time)).getMinutes()}` : (new Date(time)).getMinutes()
    
    return (
		<div className="agenda-item-end">
            <div className="agenda-item-end__datetime">
                <div className="agenda-item-end__time">
                    {`${hours}:${minutes}`}
                    <sub>UTC</sub>
                </div>
            </div>
            <div className="agenda-item-end__content">
                <p className="uikit-heading-md">{props?.time.endDayText}</p>
            </div>
        </div>
	);
}

export default AgendaItem;
